module.exports = __webpack_public_path__ + "img/1b75f77a-edb6-4983-a606-09d47f2dcf51.98ade726.jpg";